// src/config/rules.js

import { AbilityBuilder } from '@casl/ability'

export default function defineRulesFor(user) {
    const { can, cannot, rules } = AbilityBuilder.extract()

    let wildcardOperations = ['create', 
        'update', 
        'view', 
        'delete', 
        'assign', 
        'change_status', 
        'generate', 
        'outsource',
        'filter_users',
        'filter_partners',
        'filter_statuses',
        'kyc_send',
    ];

    user.permission_names.forEach(permission => {

        let [subject, operation, scope] = permission.split('.');
        
        // if wildcard
        if(operation == '*') {
            
            // Add all wildcard operations
            wildcardOperations.forEach(wildOperation => {
                can(wildOperation, subject);
            });
            return;
        }

        if(subject == 'users' && scope == 'self') {
            return;
        }

        if(subject == 'partners' && scope == 'partner') {
            return;
        }

        can(operation, subject);
        
    });

    return rules;
} 